import {Icon, IconButton, makeStyles} from "@material-ui/core";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../../../../Utils/lib";
import React from "react";

const useStyles = makeStyles(() => ({
    classificationContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        background: 'rgba(0,0,0,0.02)',
        width: '100%',
        padding: 10,
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
        '&:hover': {
            '& $actionsContainer': {
                visibility: 'visible'
            },
            '& $removeButtonContainer': {
                visibility: 'visible'
            }
        }
    },
    removeButtonContainer: {
        display: "flex",
        visibility: 'hidden'
    }
}))
const ClassificationItem = ({classification, index, dataSource, setClassificationModalState, removeGroup}) => {
    const classes = useStyles()
    const userLanguage = useSelector(state => state.app.userLanguage);

    return (
        <div
            className={classes.classificationContainer}
        >
            <div style={{width: '25%'}}>
                {classification.from}
            </div>
            <div style={{width: '25%'}}>
                {classification.to}
            </div>
            <div style={{width: '25%'}}>
                {multiLanguageValue(classification.name, userLanguage)}
            </div>
            <div style={{width: '25%'}}>
                <div style={{
                    width: '100px',
                    height: '20px',
                    background: classification.color,
                    borderRadius: '16px'
                }}/>
            </div>
            <div className={classes.removeButtonContainer}>
                <IconButton size={'small'} onClick={() => {
                    removeGroup(dataSource + '.classification.' + index)
                }}>
                    <Icon fontSize={"small"}>
                        highlight_off
                    </Icon>
                </IconButton>
                <IconButton size={'small'} onClick={() => {
                    setClassificationModalState({
                        open: true,
                        record: classification,
                        index,
                        path: `${dataSource}.classification.${index}`
                    })
                }}>
                    <Icon fontSize={"small"}>
                        edit
                    </Icon>
                </IconButton>
            </div>
        </div>
    )
}

export default ClassificationItem